import PptxGenJS from 'pptxgenjs';
import { LAYOUT, COLORS, FONTS } from '../helpers/constants';
import { addConfidentialDisclaimer, addProjectBadge, addSlideTitle } from '../template-parts';
import { PPTImageManager } from '../helpers/image-manager';

const WIDTH = LAYOUT.width;
const HEIGHT = LAYOUT.height;
const MARGIN = LAYOUT.margin;
const SLIDE_BADGE = 'advisors';

export function AdvisorsSlide(pptx: PptxGenJS, imageManager: PPTImageManager) {
  const slide = pptx.addSlide();

  // Background green
  slide.addShape(pptx.ShapeType.rect, {
    x: 0,
    y: 0,
    w: WIDTH,
    h: HEIGHT,
    fill: { color: COLORS.primary },
    line: { type: 'none' },
  });

  // Badge ADVISORS
  const badgeText = SLIDE_BADGE.toUpperCase();
  addProjectBadge(slide, badgeText, 2, COLORS.badgeGray);

  // === 4) Title Network of Advisors ===
  addSlideTitle(slide, 'Network of Advisors', COLORS.white);

  slide.addText(
    [
      { text: 'Explore our ' },
      { text: 'network of trusted advisors and service providers ', options: { bold: true } },
      { text: 'ready to support your transaction when needed.\n' },
      { text: 'Access their credentials, experience and project involvement in a single place.' },
    ],
    {
      x: MARGIN,
      y: 1.53,
      w: 6.47,
      h: 1.07,
      fontSize: 14,
      fontFace: FONTS.body,
      color: COLORS.white,
      align: 'left',
    }
  );

  // === 5) Advisors logo content
  const legalImage = imageManager.get('advisor-legal');
  slide.addText('Legal Advisors:', {
    x: MARGIN,
    y: 2.7,
    w: 2.92,
    h: 0.41,
    fontSize: 14,
    fontFace: FONTS.title,
    color: COLORS.lightPrimary,
    bold: true,
    align: 'left',
    valign: 'middle',
  });
  if (legalImage) {
    slide.addImage({
      data: legalImage,
      x: MARGIN,
      y: 3.06,
      w: 6.44,
      h: 1.38,
      sizing: { type: 'contain', w: 6.44, h: 1.38 },
    });
  }

  const technicalImage = imageManager.get('advisor-technical');
  slide.addText('Technical Advisors:', {
    x: MARGIN,
    y: 4.7,
    w: 2.92,
    h: 0.41,
    fontSize: 14,
    fontFace: FONTS.title,
    color: COLORS.lightPrimary,
    bold: true,
    align: 'left',
    valign: 'middle',
  });
  if (technicalImage) {
    slide.addImage({
      data: technicalImage,
      x: MARGIN,
      y: 5.07,
      w: 6.44,
      h: 1.38,
      sizing: { type: 'contain', w: 6.44, h: 1.38 },
    });
  }

  const financialImage = imageManager.get('advisor-financial');
  slide.addText('Financial Advisors:', {
    x: MARGIN,
    y: 6.66,
    w: 2.92,
    h: 0.41,
    fontSize: 14,
    fontFace: FONTS.title,
    color: COLORS.lightPrimary,
    bold: true,
    align: 'left',
    valign: 'middle',
  });
  if (financialImage) {
    slide.addImage({
      data: financialImage,
      x: MARGIN,
      y: 7.02,
      w: 6.45,
      h: 0.91,
      sizing: { type: 'contain', w: 6.45, h: 0.91 },
    });
  }

  const epcImage = imageManager.get('advisor-epc');
  slide.addText('EPC:', {
    x: MARGIN,
    y: 8.18,
    w: 2.92,
    h: 0.41,
    fontSize: 14,
    fontFace: FONTS.title,
    color: COLORS.lightPrimary,
    bold: true,
    align: 'left',
    valign: 'middle',
  });
  if (epcImage) {
    slide.addImage({
      data: epcImage,
      x: MARGIN,
      y: 8.52,
      w: 6.44,
      h: 0.91,
      sizing: { type: 'contain', w: 6.44, h: 0.91 },
    });
  }

  slide.addText(
    [
      { text: 'Contact us at ' },
      {
        text: 'services@nteaser.com ',
        options: { hyperlink: { url: 'mailto:services@nteaser.com' }, color: COLORS.accent, bold: true },
      },
      { text: 'for details.' },
    ],
    {
      x: MARGIN,
      y: 9.88,
      w: 4.8,
      h: 0.3,
      fontSize: 12,
      fontFace: FONTS.body,
      color: COLORS.white,
      align: 'left',
      valign: 'middle',
    }
  );

  // Confidential disclaimer
  addConfidentialDisclaimer(slide);
}
